import { TimeStepValueDTO } from './TimeStepValueDTO'
import { TimeStepMaxDTO } from './TimeStepMaxDTO'

export class SnapshotValueDTO {
  constructor(
    readonly city: string,
    readonly timestamp: string,
    readonly history: Array<TimeStepValueDTO>,
    readonly reference: TimeStepValueDTO,
    readonly forecasts: Array<TimeStepValueDTO>,
    readonly maxFrame: TimeStepMaxDTO,
  ) {}
}
